(function () {
  'use strict';

  function closeSearch(search) {
    const toggle = search.querySelector('.announcement-bar__search-toggle');
    const panel = search.querySelector('.announcement-bar__search-panel');
    const input = search.querySelector('.announcement-bar__search-input');

    if (!toggle || !panel) {
      return;
    }

    search.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Open search');

    if (input) {
      input.setAttribute('tabindex', '-1');
      input.blur();
    }
  }

  function openSearch(search) {
    const toggle = search.querySelector('.announcement-bar__search-toggle');
    const panel = search.querySelector('.announcement-bar__search-panel');
    const input = search.querySelector('.announcement-bar__search-input');

    if (!toggle || !panel) {
      return;
    }

    search.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    toggle.setAttribute('aria-expanded', 'true');
    toggle.setAttribute('aria-label', 'Close search');

    if (input) {
      input.removeAttribute('tabindex');
      window.setTimeout(function () {
        input.focus();
      }, 280);
    }
  }

  function initAnnouncementBarSearch(search) {
    if (!search || search.dataset.announcementSearchReady === 'true') {
      return;
    }

    const toggle = search.querySelector('.announcement-bar__search-toggle');
    const panel = search.querySelector('.announcement-bar__search-panel');
    const form = search.querySelector('.announcement-bar__search-form');

    if (!toggle || !panel) {
      return;
    }

    search.dataset.announcementSearchReady = 'true';

    toggle.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      if (search.classList.contains('is-open')) {
        closeSearch(search);
      } else {
        openSearch(search);
      }
    });

    if (form) {
      form.addEventListener('click', function (event) {
        event.stopPropagation();
      });
    }

    document.addEventListener('click', function (event) {
      if (!search.contains(event.target)) {
        closeSearch(search);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeSearch(search);
      }
    });
  }

  function initAnnouncementBar(root) {
    (root || document).querySelectorAll('[data-announcement-search]').forEach(initAnnouncementBarSearch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAnnouncementBar(document);
    });
  } else {
    initAnnouncementBar(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAnnouncementBar(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-announcement-search]').forEach(function (search) {
      delete search.dataset.announcementSearchReady;
    });
  });
})();
